import {
  GET_CLASSES_LIST_SUCCESS,
  // GET_CLASS_APPS,
  GET_CLASS_APPS_SUCCESS,
  SET_CLASS_LOADING,
} from '../constants/category';

const initState = {
  classes: null,
  classesSatus: true,
  classApps: {
    loading: true,
    list: [],
    pagenation: {
      code: null,
      id: null,
      tagid: null,
    },
  },
};

const category = (state = initState, action = {}) => {
  switch (action.type) {
    case GET_CLASSES_LIST_SUCCESS:
      return {
        ...state,
        classes: action.data && action.data.list,
        classesSatus: action.data && action.data.classesSatus,
      };
    // case GET_CLASS_APPS:
    //   return { ...state, classApps: action.data };
    case GET_CLASS_APPS_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const { code, id, tagid } = state.classApps.pagenation || {};
      // eslint-disable-next-line no-case-declarations
      const { code: pCode, id: pId, tagid: pTagid } = action.data.params;
      // eslint-disable-next-line no-case-declarations
      const refresh =
        action.data.params.refresh || code !== pCode || id !== pId || tagid !== pTagid;
      return {
        ...state,
        classApps: {
          ...state.classApps,
          loading: false,
          pagenation: {
            ...action.data.params,
            total: action.data.count,
          },
          list: refresh ? action.data.apps : [...state.classApps.list, ...action.data.apps],
        },
      };
    case SET_CLASS_LOADING:
      return {
        ...state,
        classApps: {
          ...state.classApps,
          loading: action.loading,
        },
      };
    default:
      return state;
  }
};

export default category;
